"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../Button"));
var _iconsReact = require("../../icons-react");
var FacilitiesTitle = function FacilitiesTitle(_ref) {
  var count = _ref.count,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    onToggle = _ref.onToggle,
    isOpened = _ref.isOpened,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(StyledTitleContainer, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, onToggle ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    functional: true,
    onClick: onToggle
  }, /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    isMobile: isMobile
  }, children), /*#__PURE__*/_react["default"].createElement(StyledCounter, null, count), /*#__PURE__*/_react["default"].createElement(StyledToggleIcon, {
    inverted: !isOpened
  })) : /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    isMobile: isMobile
  }, children)));
};
var StyledTitleContainer = _styledComponents["default"].div.withConfig({
  displayName: "FacilitiesTitle__StyledTitleContainer",
  componentId: "sc-17yi8dw-0"
})(["margin-bottom:9px;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "FacilitiesTitle__StyledTitle",
  componentId: "sc-17yi8dw-1"
})(["", " font-size:", "px;font-weight:bold;"], function (props) {
  return !props.isMobile && "\n    padding-left: 10px;\n  ";
}, function (props) {
  return props.isMobile ? 20 : 22;
});
var StyledCounter = _styledComponents["default"].span.withConfig({
  displayName: "FacilitiesTitle__StyledCounter",
  componentId: "sc-17yi8dw-2"
})(["font-size:15px;margin:2px 5px 0 10px;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "FacilitiesTitle__StyledButton",
  componentId: "sc-17yi8dw-3"
})(["display:flex;align-items:center;"]);
var StyledToggleIcon = (0, _styledComponents["default"])(_iconsReact.ArrowDown).withConfig({
  displayName: "FacilitiesTitle__StyledToggleIcon",
  componentId: "sc-17yi8dw-4"
})(["display:inline-flex;align-items:center;margin:auto 0;width:12px;height:6px;path{fill:", ";}", ""], function (props) {
  return props.theme.colors.blackBase;
}, function (props) {
  return props.inverted && "\n    transform: rotate(180deg);\n  ";
});
var _default = exports["default"] = FacilitiesTitle;